import { BrowserRouter, Routes, Route } from "react-router-dom";

import NavBar from "./components/NavBar";
import Home from "./pages/Home";
import Block from "./pages/Blocks";
import BlockDetail from "./pages/BlockDetail";
import Transactions from "./pages/Transactions";
import TransactionDetail from "./pages/TransactionDetail";

const App = () => {
  return (
    <div className="App">
      <NavBar />
      <div
        style={{
          padding: "32px",
          background: "rgba(200, 200, 0, 0.1)",
          minHeight: "100vh",
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route path="/">
              <Route index element={<Home />} />
              <Route path="/blocks/:blockHeight" element={<BlockDetail />} />
              <Route path="/blocks" element={<Block />} />
              <Route path="/tx/:txHash" element={<TransactionDetail />} />
              <Route path="/transactions" element={<Transactions />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  );
};

export default App;
